module.exports = __webpack_public_path__ + "static/media/locationitemicon.0e8f5aa8.svg";